import React from "react";

import RegistrationWizard from "./app_widgets/self_registration/RegistrationWizard";

const SelfRegistrationComponent = () => {
  return (
    <>
      <RegistrationWizard />
    </>
  );
};

export default SelfRegistrationComponent;
